/**
 * Keeping Care Color System
 *
 * Uses descriptive/semantic names to describe purpose, not color.
 * See DESIGN.md for full color usage guidelines.
 *
 * Brand palette reference:
 *   Sienna (#A15D36), Camel (#A17353), Aubergine (#352935),
 *   Amber (#BE7435), Lichen (#C8C446)
 */

const colors = {
  // ─────────────────────────────────────────────────────────────
  // Primary Actions (buttons, links, interactive elements)
  // ─────────────────────────────────────────────────────────────
  button: '#A15D36',            // Primary button background
  buttonHover: '#c4836a',       // Primary button hover
  buttonSecondary: '#A17353',   // Secondary/outline button
  buttonSecondaryHover: '#c49b85',
  link: '#A15D36',              // Link text
  linkVisited: '#A17353',       // Visited link
  focus: '#A15D36',             // Focus rings

  // ─────────────────────────────────────────────────────────────
  // Backgrounds
  // ─────────────────────────────────────────────────────────────
  background: '#f7f5f2',        // Page background (cream)
  backgroundAlt: '#ede9e3',     // Alternate/card background (linen)
  card: '#e5e0d8',              // Elevated card background (parchment)
  header: '#352935',            // Header/footer background (aubergine)
  headerAlt: '#3d3540',         // Alternate dark (charcoal)
  overlay: 'rgba(53, 41, 53, 0.7)', // Modal overlay

  // ─────────────────────────────────────────────────────────────
  // Text
  // ─────────────────────────────────────────────────────────────
  text: '#352935',              // Primary text (aubergine)
  textLight: '#4a444e',         // Secondary/subtle text (deeper slate)
  textMuted: '#706b63',         // Placeholder, disabled text (stone)
  textOnDark: '#f7f5f2',        // Text on dark backgrounds (cream)
  textOnDarkMuted: 'rgba(247, 245, 242, 0.85)', // Subtle text on dark

  // ─────────────────────────────────────────────────────────────
  // Borders & Dividers
  // ─────────────────────────────────────────────────────────────
  border: '#a8a39b',            // Standard borders (warm gray)
  borderStrong: '#A17353',      // Emphasized borders (camel)
  borderFocus: '#A15D36',       // Focus state border
  divider: '#a8a39b',           // Divider lines (warm gray)

  // ─────────────────────────────────────────────────────────────
  // Status & Feedback
  // ─────────────────────────────────────────────────────────────
  success: '#9a9630',           // Success states (olive)
  successLight: '#b8ba5a',      // Light success
  warning: '#BE7435',           // Warning states (amber)
  warningLight: '#d4995c',      // Light warning
  error: '#a04040',             // Error states
  danger: '#a04040',            // Alias for error
  info: '#A17353',              // Informational (camel)

  // ─────────────────────────────────────────────────────────────
  // Accents & Highlights
  // ─────────────────────────────────────────────────────────────
  accent: '#BE7435',            // Highlight/warmth (amber)
  accentLight: '#d4995c',       // Lighter accent

  // ─────────────────────────────────────────────────────────────
  // Component-specific (for Switch, Toggle, etc.)
  // ─────────────────────────────────────────────────────────────
  switchTrack: '#a8a39b',       // Inactive switch track (warm gray)
  switchTrackActive: '#c4836a', // Active switch track
  switchThumb: '#706b63',       // Inactive switch thumb (stone)
  switchThumbActive: '#A15D36', // Active switch thumb

  // ─────────────────────────────────────────────────────────────
  // Legacy aliases (backward compatibility)
  // ─────────────────────────────────────────────────────────────
  lightButton: '#c4836a',       // Alias for buttonHover
  notice: '#BE7435',            // Alias for warning
};

export default colors;
